import { render, staticRenderFns } from "./input-moeda.vue?vue&type=template&id=4779c5c4"
import script from "./input-moeda.vue?vue&type=script&lang=ts"
export * from "./input-moeda.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports